import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';
import {
  ADD_PROGRESS_LOG,
  END_LOAD_APP, SET_PROGRESS_LIST,
  HIDE_CONFIRM, HIDE_SIGN_POPUP, INIT_CADES_STORE, LOAD_CADES_STORE,
  LOAD_STATUS,
  SET_LOCALE,
  SET_MENU_STATE,
  SHOW_CONFIRM, SHOW_PROGRESS_BAR, SHOW_SIGN_POPUP, SIGN_DOCUMENT,
  START_LOAD_APP,
  SET_LOG_LIST,
  UPDATE_PERIOD, CLOSE_PROGRESS_BAR, STOP_PROGRESS_BAR,
} from './actions';
import { LOCAL_STORAGE_LOCALE, LOCAL_STORAGE_UPDATE_PERIOD } from '../../configs/names';
import { DEFAULT_LOCALE_SHORT } from '../../configs';
import { AUTHORIZED_MODULE, SYSTEM_MODULE } from '../../configs/moduleNames';
import {
  createLoadParameterReducer,
  createOperationStateReducer,
  updateLoadParameterReducer,
} from '../../utils/getCrudConfig';
import { AUTHORIZED_LOGOUT } from '../Authorized/actions';
import { FAILED, SUCCESSFUL } from '../../configs/actionNames';

const initialState = {
  locale: window.localStorage.getItem(LOCAL_STORAGE_LOCALE) || DEFAULT_LOCALE_SHORT,
  showConfirm: false,
  confirmTitle: '',
  confirmMessage: '',
  confirmClassName: '',
  promiseId: null,
  isOpenMenu: false,
  loadApp: true,
  updatePeriod: Number(window.localStorage.getItem(LOCAL_STORAGE_UPDATE_PERIOD)) || 0,
  loadingStatus: false,
  status: {},
  cadesCertificates: [],
  loadingCadesCertificates: false,
  cadesState: null,
  loadingSignDocument: false,
  signPromiseId: null,
  showSignPopup: false,
  stopProgressBar: false,
  showProgressBar: false,
  progressBarPromiseId: null,
  progressBarTitle: '',
  progressText: '',
  progressLog: '',
  loadingCreateExportTask: false,
  loadingDownloadExportResult: false,
  loadingGetExportTaskStatus: false,
  loadingGetExportAvailableColumns: false,
};

const reducer = handleActions({
  [SYSTEM_MODULE + SET_LOCALE]: (state, action) => {
    const locale = action.payload;
    window.localStorage.setItem(LOCAL_STORAGE_LOCALE, locale);
    return {
      ...state,
      locale,
    };
  },
  [SYSTEM_MODULE + SET_MENU_STATE]: (state, action) => ({
    ...state,
    isOpenMenu: action.payload,
  }),

  [SYSTEM_MODULE + SHOW_CONFIRM]: (state, action) => {
    const {
      payload: {
        confirmTitle = '',
        confirmMessage = '',
        confirmClassName = '',
        confirmButtonText = '',
        confirmCancelButtonText = '',
        hideSubmit = false,
      } = {
        confirmTitle: '',
        confirmMessage: '',
        confirmClassName: '',
        confirmButtonText: '',
        confirmCancelButtonText: '',
        hideSubmit: false,
      },
      promiseId,
    } = action;
    return {
      ...state,
      showConfirm: true,
      confirmTitle,
      confirmMessage,
      confirmClassName,
      confirmButtonText,
      confirmCancelButtonText,
      promiseId,
      hideSubmit,
    };
  },
  [SYSTEM_MODULE + HIDE_CONFIRM]: state => ({
    ...state,
    showConfirm: false,
    confirmTitle: '',
    confirmMessage: '',
    confirmClassName: '',
    promiseId: null,
    hideSubmit: false,
  }),
  [SYSTEM_MODULE + START_LOAD_APP]: state => ({
    ...state,
    loadApp: true,
  }),
  [SYSTEM_MODULE + END_LOAD_APP]: state => ({
    ...state,
    loadApp: false,
  }),
  [SYSTEM_MODULE + UPDATE_PERIOD]: (state, action) => {
    const updatePeriod = action.payload;
    window.localStorage.setItem(LOCAL_STORAGE_UPDATE_PERIOD, updatePeriod);
    return {
      ...state,
      updatePeriod,
    };
  },
  [AUTHORIZED_MODULE + AUTHORIZED_LOGOUT + SUCCESSFUL]: state => ({
    ...state,
    status: {},
  }),
  [INIT_CADES_STORE]: (state, action) => ({
    ...state,
    cadesState: action.payload,
  }),

  [SYSTEM_MODULE + SHOW_SIGN_POPUP]: (state, action) => {
    const { promiseId } = action;
    return {
      ...state,
      showSignPopup: true,
      signPromiseId: promiseId,
    };
  },
  [SYSTEM_MODULE + HIDE_SIGN_POPUP]: state => ({
    ...state,
    showSignPopup: false,
    signPromiseId: null,
  }),
  [SYSTEM_MODULE + ADD_PROGRESS_LOG]: (state, action) => {
    const {
      progressLog,
      progressCountSuccess,
      progressCountError,
      stopProgressBar,
      progressNotFound,
      progressSaved,
    } = state;
    const {
      log,
      incSuccess,
      incError,
      withOutTime = false,
      incNotFound,
      incSaved,
    } = action.payload;
    if (stopProgressBar) {
      return {
        ...state,
      };
    }
    const time = moment().format('HH:mm:ss');
    return {
      ...state,
      progressLog: [...progressLog, withOutTime ? log : `${time} - ${log}`],
      progressCountSuccess: incSuccess ? progressCountSuccess + 1 : progressCountSuccess,
      progressCountError: incError ? progressCountError + 1 : progressCountError,
      progressNotFound: incNotFound ? progressNotFound + 1 : progressNotFound,
      progressSaved: incSaved ? progressSaved + 1 : progressSaved,
    };
  },
  [SYSTEM_MODULE + SET_PROGRESS_LIST]: (state, action) => {
    const { progressCount, progressPercent = 0, progressCountSuccess = 0 } = action.payload;
    return {
      ...state,
      progressCount,
      progressPercent,
      progressCountSuccess,
      progressCountError: 0,
      // showProgressBar: true,
      progressNotFound: 0,
      progressSaved: 0,
    };
  },
  [SYSTEM_MODULE + SET_LOG_LIST]: (state, action) => {
    const { log = [] } = action.payload;
    return {
      ...state,
      progressLog: log,
    };
  },
  [SYSTEM_MODULE + CLOSE_PROGRESS_BAR]: state => ({
    ...state,
    progressCount: 0,
    progressCountSuccess: 0,
    progressCountError: 0,
    showProgressBar: false,
    progressLog: [],
    stopProgressBar: true,
    progressNotFound: 0,
    progressSaved: 0,
    progressBarPromiseId: null,
  }),
  [SYSTEM_MODULE + STOP_PROGRESS_BAR]: state => ({
    ...state,
    stopProgressBar: true,
  }),
  [SYSTEM_MODULE + SHOW_PROGRESS_BAR]: (state, action) => {
    const { promiseId, payload } = action;
    const { title, text } = payload;
    return ({
      ...state,
      showProgressBar: true,
      stopProgressBar: false,
      progressBarPromiseId: promiseId,
      progressBarTitle: title,
      progressText: text,
      progressLog: [],
      progressCount: 0,
      progressCountSuccess: 0,
      progressCountError: 0,
    });
  },
  ...updateLoadParameterReducer(SYSTEM_MODULE + LOAD_STATUS, 'status', 'loadingStatus', {}),
  ...createLoadParameterReducer(LOAD_CADES_STORE, 'cadesCertificates', 'loadingCadesCertificates', []),
  ...createOperationStateReducer(SYSTEM_MODULE + SIGN_DOCUMENT, 'loadingSignDocument'),
}, initialState);

export default reducer;

export const getGlobalConfirmData = createSelector(
  [state => state[SYSTEM_MODULE]],
  state => {
    const {
      showConfirm = false,
      confirmTitle = '',
      confirmMessage = '',
      confirmClassName = '',
      confirmButtonText = '',
      confirmCancelButtonText = '',
      hideSubmit = false,
      promiseId = null,
    } = state;
    return {
      showConfirm,
      confirmTitle,
      confirmMessage,
      confirmClassName,
      confirmButtonText,
      confirmCancelButtonText,
      hideSubmit,
      promiseId,
    };
  },
);

export const getSystemData = createSelector(
  [state => state[SYSTEM_MODULE]],
  state => {
    const {
      loadApp = false,
      locale = '',
      updatePeriod = 0,
      loadingStatus = false,
      loadingSignDocument = false,
      status = {},
    } = state;
    return {
      locale,
      loadApp,
      updatePeriod,
      loadingStatus,
      status,
      loadingSignDocument,
    };
  },
);

export const getCadesData = createSelector(
  [state => state[SYSTEM_MODULE]],
  state => {
    const {
      cadesCertificates,
      loadingCadesCertificates,
      cadesState,
      loadingSignDocument,
      showSignPopup,
      signPromiseId,
    } = state;
    return {
      cadesCertificates,
      loadingCadesCertificates,
      cadesState,
      loadingSignDocument,
      showSignPopup,
      signPromiseId,
    };
  },
);

export const progressBarData = createSelector(
  [state => state[SYSTEM_MODULE]],
  state => {
    const {
      stopProgressBar,
      showProgressBar,
      progressBarPromiseId,
      progressBarTitle,
      progressText,
      progressLog,
      progressCount,
      progressCountSuccess,
      progressCountError,
      progressPercent,
    } = state;
    return {
      stopProgressBar,
      showProgressBar,
      progressBarPromiseId,
      progressBarTitle,
      progressText,
      progressLog,
      progressCount,
      progressCountSuccess,
      progressCountError,
      progressPercent,
    };
  },
);

export const getExportData = createSelector(
  [state => state[SYSTEM_MODULE]],
  state => {
    const {
      loadingCreateExportTask,
      loadingDownloadExportResult,
      loadingGetExportTaskStatus,
      loadingGetExportAvailableColumns,
    } = state;
    return {
      loadingCreateExportTask,
      loadingDownloadExportResult,
      loadingGetExportTaskStatus,
      loadingGetExportAvailableColumns,
    };
  },
);
